import { Box, Typography, Button, CircularProgress } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useAppContext } from "../../context/AppContext";
import Layout from "../../components/Layout";
import BeginSurveyCard from "../../components/BeginSurveyCard";
import "../../index.css";
import { Img_1, Img_2, Img_3 } from "../../assets";

import { createSession } from "../../components/SessionProvider";
import { useEffect } from "react";
// import ApiService from "../../services/api";

const DistributorWelcome = () => {
  const {
    setCurrentView,
    setSnackbar,
    distributorId,
    sessionId,
    setSessionId,
    setSessionError,
    getTranslation,
    setRole,
    role,
    currentLanguage,
    enableSessionToCreateNew,
    setEnableSessionToCreateNew,
    // fetchUserProfiles,
    // setDistributorId,
    // token,
  } = useAppContext();


  useEffect(() => {
    const initializeSession = async () => {
      // If session already exists in state, use it and don't create a new one
      if (sessionId) {
        setEnableSessionToCreateNew(false);
        return;
      }

      if (!enableSessionToCreateNew) {
        return;
      }

      if (!distributorId) {
        return;
      }
      // On first app open (when sessionId is null), always create a session
      // Or create if enableSessionToCreateNew flag is explicitly set to true
      try {
        const language = currentLanguage || "en";
        await createSession(
          setSessionId,
          setSessionError,
          language,
          undefined,
          setRole,
          distributorId || undefined,
          undefined
        );
        // setSnackbar({
        //   open: true,
        //   severity: "success",
        //   message: getTranslation("Session created successfully")
        // });
        // Reset the flag to false after successfully creating session
        setEnableSessionToCreateNew(false);
      } catch (error) {
        console.error("Failed to create session:", error);
        // setSnackbar({
        //   open: true,
        //   severity: "error",
        //   message: getTranslation("Failed to create session")
        // });
        // Reset the flag even on error to prevent infinite retries
        setEnableSessionToCreateNew(false);
      }
    };

    initializeSession();
    
  }, [sessionId, setSessionId, setSessionError, distributorId, enableSessionToCreateNew, currentLanguage, setRole, setEnableSessionToCreateNew]);

  const isSessionPending = !sessionId;

  const distributorCards = [
    {
      title: getTranslation("TXt995"),
      description: getTranslation("Txt478"),
      image: Img_1,
      buttonText: getTranslation("Txt424"),
      action: () => setCurrentView("user-info"),
      disabled: isSessionPending,
      loading: isSessionPending,
    },
    {
      title: getTranslation("Txt480"),
      description: getTranslation("Txt481"),
      image: Img_2,
      buttonText: getTranslation("Txt427"),
      action: () => setCurrentView("DistributorUserDetails"),
      disabled: isSessionPending,
      loading: isSessionPending,
    },
    {
      title: getTranslation("Txt996"),
      description: getTranslation("Txt484"),
      image: Img_3,
      buttonText: getTranslation("Txt486"),
      action: () => handleCopyLink(),
      isLinkCard: true,
    },
  ];

  const handleCopyLink = async () => {
    const baseUrl = window.location.origin;
    const link = `${baseUrl}/customer/${distributorId}`;

    try {
      await navigator.clipboard.writeText(link);
      setSnackbar({
        open: true,
        message: getTranslation("Txt902" ),
        severity: "success",
      });
    } catch (err) {
      console.error("Failed to copy link:", err);
      setSnackbar({
        open: true,
        message: getTranslation("Err85"),
        severity: "error",
      });
    }
  };


  return (
    <Layout showBackButton={false}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { 
            xs: "50px", 
            md: "20px",
            lg: "25px",
            xl: "30px"
          },
          alignItems: "center",
          justifyContent: { xs: "space-between", md: "flex-start" },
          padding: { 
            xs: "20px 0", 
            md: "10px 15px",
            lg: "15px 20px",
            xl: "20px 25px"
          },
          maxWidth: { 
            md: "1200px",
            lg: "1400px",
            xl: "1600px"
          },
          margin: "0 auto",
          // minHeight: "100vh",      // Ensure minimum viewport height
          width: "100%",
          paddingTop: { 
            md: "40px",
            lg: "50px",
            xl: "60px"
          },
          paddingBottom: "40px",   // Add bottom padding for scroll space
          // overflow: "auto",        // Allow scrolling when content exceeds viewport
          boxSizing: "border-box"  // Include padding in height calculation
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { 
              xs: "20px", 
              md: "30px",
              lg: "35px",
              xl: "40px"
            },
            alignItems: { xs: "center", md: "center" },
            justifyContent: { xs: "flex-start", md: "flex-start" },
            width: "100%",
            flex: 1,
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: { 
                xs: "30px", 
                md: '25px',
                lg: '30px',
                xl: '35px'
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: { 
                  xs: "30px", 
                  md: '8px',
                  lg: '10px',
                  xl: '12px'
                },
              }}
            >
              <Typography
                sx={{
                  color: "var(--color-text-primary)",
                  textAlign: "center",
                  fontSize: { 
                    xs: "14px",
                    sm: "24px",
                    md: "36px",
                    lg: "28px",
                    xl: "32px"
                  },
                  fontStyle: "normal",
                  fontWeight: { xs: 400, md: 600, lg: 600 },
                  lineHeight: { 
                    xs: "1.2", 
                    md: "1.3", 
                    lg: "1.2", 
                    xl: "1.1" 
                  },
                  letterSpacing: { 
                    md: "0.3px", 
                    lg: "0.5px", 
                    xl: "0.8px" 
                  },
                  marginBottom: { 
                    md: "6px", 
                    lg: "10px", 
                    xl: "15px" 
                  },
                  fontFamily: "HerbalifeFont"
                }}
              >
                {getTranslation("Txt1001")}
              </Typography>
              <Typography
                sx={{
                  color: "var(--color-text-secondary)",
                  textAlign: "center",
                  fontSize: { 
                    xs: "14px",
                    sm: "18px",
                    md: "24px",
                    lg: "18px",
                    xl: "20px"
                  },
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: { 
                    xs: "1.2", 
                    md: "1.4", 
                    lg: "1.3", 
                    xl: "1.2" 
                  },
                  letterSpacing: { 
                    md: "0.2px", 
                    lg: "0.3px", 
                    xl: "0.5px" 
                  },
                  maxWidth: { 
                    md: "480px",     // 1280x720 - compact width
                    lg: "580px",     // 1366x657 - moderate width
                    xl: "750px"      // 1920x950 - generous width
                  },
                  fontFamily: "HerbalifeFont"
                }}
              >
                {getTranslation("Txt418")}
              </Typography>
            </Box>

            {/* Mobile Design (xs, sm) */}
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "400px", sm: "560px" },
                display: { xs: "block", md: "none" },
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: "20px", sm: "24px" },
                  width: "100%",
                }}
              >
                {distributorCards.map((card, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      padding: { xs: "16px", sm: "20px" },
                      borderRadius: { xs: "12px", sm: "16px" },
                      backgroundColor: "var(--color-background)",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      gap: { xs: "16px", sm: "20px" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        gap: { xs: "16px", sm: "20px" },
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: "60px", sm: "72px" },
                          height: { xs: "60px", sm: "72px" },
                          borderRadius: "50%",
                          overflow: "hidden",
                          flexShrink: 0,
                          border: "2px solid #e0e0e0",
                        }}
                      >
                        <Box
                          component="img"
                          src={card.image}
                          alt={card.title}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: "6px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "var(--color-text-primary)",
                            fontSize: { xs: "16px", sm: "18px" },
                            fontWeight: 600,
                            lineHeight: "1.2", 
                          }}
                        >
                          {card.title}
                        </Typography>

                        <Typography
                          sx={{
                            color: "var(--color-text-secondary)",
                            fontSize: { xs: "14px", sm: "16px" },
                            fontWeight: 400,
                            lineHeight: "1.3",
                          }}
                        >
                          {card.description}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: card.isLinkCard ? "stretch" : "flex-end",
                        width: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                      }}
                    >
                      {card.isLinkCard ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            minWidth: 0,
                            border: "2px dashed #ccc",
                            borderRadius: "8px",
                            backgroundColor: "var(--color-background)",
                            padding: "6px 6px 6px 10px",
                            gap: 0.75,
                            boxSizing: "border-box",
                          }}
                        >
                          <Typography
                            sx={{
                              flex: 1,
                              minWidth: 0,
                              fontSize: { xs: "11px", sm: "13px" },
                              color: "var(--color-text-secondary)",
                              fontFamily: "HerbalifeFont",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {`${window.location.origin}/customer/${distributorId}`}
                          </Typography>
                          <Button
                            onClick={card.action}
                            endIcon={<ContentCopyIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />}
                            sx={{
                              flexShrink: 0,
                              backgroundColor: "#000",
                              color: "#FFF",
                              borderRadius: "6px",
                              textTransform: "none",
                              fontWeight: 500,
                              fontFamily: "HerbalifeFont",
                              fontSize: { xs: "12px", sm: "14px" },
                              px: 1.25,
                              py: 0.75,
                              whiteSpace: "nowrap",
                              boxShadow: "none",
                              "&:hover": { backgroundColor: "#333", boxShadow: "none" },
                            }}
                          >
                            {card.buttonText}
                          </Button>
                        </Box>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={card.action}
                          disabled={card.disabled}
                          sx={{
                            padding: { xs: "8px 16px", sm: "10px 20px" },
                            borderRadius: "6px",
                            background: card.disabled ? "#ccc" : "var(--color-primary)",
                            fontSize: { xs: "14px", sm: "16px" },
                            color: "#FFF",
                            textTransform: "none",
                            fontWeight: 500,
                            minWidth: { xs: "100px", sm: "120px" },
                            height: { xs: "36px", sm: "42px" },
                            "&:hover": {
                              background: card.disabled ? "#ccc" : "#333",
                            },
                          }}
                        >
                          {card.loading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            card.buttonText
                          )}
                        </Button>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Desktop Design (md and up) */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                flexDirection: "row",
                gap: {
                  md: "24px",
                  lg: "30px",
                  xl: "35px",
                },
                alignItems: "stretch",
                justifyContent: "center",
                width: "100%",
                maxWidth: {
                  md: "100%",
                  lg: "1000px",
                  xl: "1300px",
                },
                padding: {
                  md: "20px 16px",
                  lg: "20px 0",
                  xl: "25px 0",
                },
                boxSizing: "border-box",
              }}
            >
              {distributorCards.map((card, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    padding: {
                      md: "28px 20px",
                      lg: "30px",
                      xl: "35px",
                    },
                    borderRadius: {
                      md: "20px",
                      lg: "24px",
                      xl: "28px",
                    },
                    border: "1px solid #e8e8e8",
                    backgroundColor: "#FFF",
                    boxShadow: {
                      md: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      lg: "0 3px 12px rgba(0, 0, 0, 0.05)",
                      xl: "0 4px 16px rgba(0, 0, 0, 0.06)",
                    },
                    gap: {
                      md: "20px",
                      lg: "25px",
                      xl: "30px",
                    },
                    height: "auto",
                    justifyContent: "space-between",
                    width: {
                      md: "300px",
                      lg: "300px",
                      xl: "400px",
                    },
                    flexShrink: 0,
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        md: "120px",
                        lg: "100px",
                        xl: "110px",
                      },
                      height: {
                        md: "120px",
                        lg: "100px",
                        xl: "110px",
                      },
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "3px solid #f0f0f0",
                      backgroundColor: "#f8f8f8",
                      boxShadow: { 
                        md: '0 3px 12px rgba(0, 0, 0, 0.08)', 
                        lg: '0 4px 15px rgba(0, 0, 0, 0.1)', 
                        xl: '0 5px 18px rgba(0, 0, 0, 0.12)' 
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src={card.image}
                      alt={card.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      width: "100%",
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "var(--color-text-primary)",
                        textAlign: "center",
                        fontFamily: "HerbalifeFont",
                        fontSize: {
                          md: "24px",
                          lg: "20px",
                          xl: "22px",
                        },
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: { md: '1.3', lg: '1.2' },
                        margin: 0,
                        letterSpacing: { 
                          md: '0.3px', 
                          lg: '0.5px', 
                          xl: '0.7px' 
                        }
                      }}
                    >
                      {card.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: "var(--color-text-secondary)",
                        textAlign: "center",
                        fontFamily: "HerbalifeFont",
                        fontSize: { 
                          md: "20px",
                          lg: "15px",
                          xl: "16px"
                        },
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: { 
                          md: "1.5", 
                          lg: "1.4", 
                          xl: "1.3" 
                        },
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        minWidth: 0,
                        maxWidth: {
                          md: "100%",
                          lg: "300px",
                          xl: "350px",
                        },
                        letterSpacing: { 
                          md: '0.2px', 
                          lg: '0.3px', 
                          xl: '0.4px' 
                        }
                      }}
                    >
                      {card.description}
                    </Typography>
                  </Box>

                  {card.isLinkCard ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0,
                        alignSelf: "stretch",
                        border: "2px dashed #ccc",
                        borderRadius: "8px",
                        backgroundColor: "var(--color-background)",
                        padding: { md: "6px", lg: "8px 8px 8px 12px" },
                        gap: { md: 0.5, lg: 1 },
                        boxSizing: "border-box",
                      }}
                    >
                      <Typography
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          fontSize: { md: "18px", lg: "14px" },
                          color: "var(--color-text-secondary)",
                          fontFamily: "HerbalifeFont",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {`${window.location.origin}/customer/${distributorId}`}
                      </Typography>
                      <Button
                        onClick={card.action}
                        endIcon={
                          <ContentCopyIcon
                            sx={{ fontSize: { md: "18px", lg: "18px" } }}
                          />
                        }
                        sx={{
                          flexShrink: 0,
                          backgroundColor: "#000",
                          color: "#FFF",
                          borderRadius: "6px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontFamily: "HerbalifeFont",
                          fontSize: { md: "18px", lg: "14px" },
                          px: { md: 1.25, lg: 1.5 },
                          py: 0.75,
                          whiteSpace: "nowrap",
                          boxShadow: "none",
                          "&:hover": { backgroundColor: "#333", boxShadow: "none" },
                        }}
                      >
                        {card.buttonText}
                      </Button>
                    </Box>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={card.action}
                      disabled={card.disabled}
                      sx={{
                        width: {
                          md: "180px",
                          lg: "150px",
                          xl: "160px",
                        },
                        height: {
                          md: "48px",
                          lg: "42px",
                          xl: "45px",
                        },
                        borderRadius: { 
                          md: '6px', 
                          lg: '8px', 
                          xl: '10px' 
                        },
                        background: card.disabled ? "#ccc" : "#000",
                        fontSize: {
                          md: "18px",
                          lg: "15px",
                          xl: "16px",
                        },
                        color: "#FFF",
                        textTransform: "none",
                        fontWeight: 500,
                        fontFamily: 'HerbalifeFont',
                        letterSpacing: { 
                          md: '0.3px', 
                          lg: '0.4px', 
                          xl: '0.6px' 
                        },
                        boxShadow: card.disabled ? "none" : { 
                          md: '0 3px 12px rgba(0, 0, 0, 0.15)', 
                          lg: '0 4px 15px rgba(0, 0, 0, 0.2)', 
                          xl: '0 5px 18px rgba(0, 0, 0, 0.25)' 
                        },
                        "&:hover": {
                          background: card.disabled ? "#ccc" : "#333",
                          transform: card.disabled ? "none" : "scale(1.05)",
                          boxShadow: card.disabled ? "none" : { 
                            md: '0 5px 18px rgba(0, 0, 0, 0.25)', 
                            lg: '0 6px 20px rgba(0, 0, 0, 0.3)', 
                            xl: '0 8px 25px rgba(0, 0, 0, 0.35)' 
                          },
                        },
                      }}
                    >
                      {card.loading ? (
                        <CircularProgress size={22} color="inherit" />
                      ) : (
                        card.buttonText
                      )}
                    </Button>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <BeginSurveyCard
          title={getTranslation("Txt997")}
          buttonText={getTranslation("Txt956")}
          role={role}
          currentLanguage={currentLanguage}
        />
      </Box>
    </Layout>
  );
};

export default DistributorWelcome;
